import { FC } from "react";

export const InactiveSparkline: FC = () => {
    return (
        <svg
            viewBox="0 0 158 79"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            preserveAspectRatio="none"
        >
            <path
                d="M158 9.43243C144.833 9.43243 144.833 24.1289 131.667 24.129C118.5 24.129 118.5 48.2216 105.333 48.2216C92.1667 48.2216 92.1667 24.129 79 24.129C65.8333 24.129 65.8333 1 52.6667 1C39.5 1 39.5 24.129 26.3333 24.129C13.1667 24.129 13.1667 40.8332 0 40.8332V79H158V9.43243Z"
                fill="url(#paint0_linear_9230_20639)"
            />
            <path
                opacity="0.25"
                d="M158 9.43243C144.833 9.43243 144.833 24.1289 131.667 24.129C118.5 24.129 118.5 48.2216 105.333 48.2216C92.1667 48.2216 92.1667 24.129 79 24.129C65.8333 24.129 65.8333 1 52.6667 1C39.5 1 39.5 24.129 26.3333 24.129C13.1667 24.129 13.1667 40.8332 0 40.8332"
                stroke="#101828"
                strokeOpacity="0.35"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_9230_20639"
                    x1="79"
                    y1="1"
                    x2="79"
                    y2="79"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#B5B7C0" stopOpacity="0.1" />
                    <stop offset="1" stopColor="#B5B7C0" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
